import * as type from "../types";

export function beneficiaryOrganizationSelect(organization) {
  return {
    type: type.BENEFICIARY_ORGANIZATION_SELECT,
    payload: organization,
  };
}
export function historyOrganizationSelect(organization) {
  return {
    type: type.HISTORY_ORGANIZATION_SELECT,
    payload: organization,
  };
}
export function setActiveRedemptionsTitle(title) {
  return {
    type: type.SET_ACTIVE_REDEMPTIONS_TITLE,
    payload: title,
  };
}
export function setActiveRedemptionsStartDate(date) {
  return {
    type: type.SET_ACTIVE_REDEMPTIONS_START_DATE,
    payload: date,
  };
}
export function setActiveRedemptionsEndDate(date) {
  return {
    type: type.SET_ACTIVE_REDEMPTIONS_END_DATE,
    payload: date,
  };
}
export function setRedemptionsHistoryTitle(title) {
  return {
    type: type.SET_REDEMPTIONS_HISTORY_TITLE,
    payload: title,
  };
}
export function setRedemptionsHistoryStartDate(date) {
  return {
    type: type.SET_REDEMPTIONS_HISTORY_START_DATE,
    payload: date,
  };
}
export function setRedemptionsHistoryEndDate(date) {
  return {
    type: type.SET_REDEMPTIONS_HISTORY_END_DATE,
    payload: date,
  };
}
export function setRedemptionsHistoryStatus(status) {
  return {
    type: type.SET_REDEMPTIONS_HISTORY_STATUS,
    payload: status,
  };
}
export function activeRedemptionSearchRequest(value) {
  return {
    type: type.ACTIVE_REDEMPTIONS_SEARCH_REQUESTED,
    payload: value,
  };
}
export function activeRedemptionSearchSucceeded(data) {
  return {
    type: type.ACTIVE_REDEMPTIONS_SEARCH_SUCCEEDED,
    payload: data,
  };
}
export function activeRedemptionSearchFailed() {
  return {
    type: type.ACTIVE_REDEMPTIONS_SEARCH_FAILED,
  };
}
export function historyRedemptionSearchRequest(value) {
  return {
    type: type.HISTORY_REDEMPTIONS_SEARCH_REQUESTED,
    payload: value,
  };
}
export function historyRedemptionSearchSucceeded(data) {
  return {
    type: type.HISTORY_REDEMPTIONS_SEARCH_SUCCEEDED,
    payload: data,
  };
}
export function historyRedemptionSearchFailed() {
  return {
    type: type.HISTORY_REDEMPTIONS_SEARCH_FAILED,
  };
}
export function setFilterConsumptionPeriod(value) {
  return {
    type: type.SET_FILTER_CONSUMPTION_PERIOD,
    payload: value,
  };
}
export function getConsumptionDataRequested(filter) {
  return {
    type: type.GET_CONSUMPTION_DATA_REQUESTED,
    payload: filter,
  };
}
export function getConsumptionDataSucceeded(data) {
  return {
    type: type.GET_CONSUMPTION_DATA_SUCCEEDED,
    payload: data,
  };
}
export function getConsumptionDataFailed() {
  return {
    type: type.GET_CONSUMPTION_DATA_FAILED,
  };
}
